import baseURL from './Api';

const getCsrfToken = async () => {
  await baseURL.get('/sanctum/csrf-cookie');
};

export default getCsrfToken;
